export const RESULTS_PER_PAGE = 10
